import { render, staticRenderFns } from "./GallerySection.vue?vue&type=template&id=2f10526e&"
import script from "./GallerySection.vue?vue&type=script&lang=js&"
export * from "./GallerySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f10526e')) {
      api.createRecord('2f10526e', component.options)
    } else {
      api.reload('2f10526e', component.options)
    }
    module.hot.accept("./GallerySection.vue?vue&type=template&id=2f10526e&", function () {
      api.rerender('2f10526e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/sections/GallerySection.vue"
export default component.exports